import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import Navigation from './ulr-navigation';
import Landing from './landing';
import Report from './report';
import Glossary from '../shared/glossary';
import { Suspense, lazy } from 'preact/compat';
const Tooltip = lazy(
    () => import(/* webpackChunkName: "tooltip" */ '../../tooltip/tooltip')
);
import PrintIcon from '../shared/print-icon';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import _ from 'underscore';
import { reportGoTo } from '../shared/accordion-scroll';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor() {
        super();
        this.mainnavs = [
            {
                text: 'Your Birth Chart',
                slug: 'your-birth-chart',
            },
            {
                text: 'Your Report',
                slug: 'your-report',
            },
            {
                text: 'Glossary',
                slug: 'glossary',
            },
        ];

        this.prev_link = null;
        this.next_link = null;
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.report != this.props.report) {
            return true;
        }

        if (nextProps.route != this.props.route) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextProps.has_birth_time != this.props.has_birth_time) {
            return true;
        }

        return false;
    }

    render(props) {
        return (
            <ultimate-love-report>
                {this.renderHeader()}
                <Navigation mainnavs={this.mainnavs} />
                <Landing
                    renderName={this.renderName}
                    renderBirthDate={this.renderBirthDate}
                    renderBirthTime={this.renderBirthTime}
                    renderBirthLocation={this.renderBirthLocation}
                />
                <Report />
                <Glossary selector='ultimate-love-report' upc={props.report.product_code} />
                {this.renderFooter()}
                {this.renderPrintFooter()}
            </ultimate-love-report>
        );
    }

    /* eslint-disable max-len */
    renderHeader = () => {
        if (this.props.route && (this.props.route.match(/^your-report/) || this.props.route.match(/^glossary/))) {
            return (
                <div className='has-text-center ulr-header'>
                    <p className='has-text-oslo-grey is-hidden-print'>{dayjs(this.props.report.product.created).format('MMMM D, YYYY')}</p>
                    <h1 className='fancy-title'>{this.props.report.product.display.name}</h1>
                    <p className='has-margin-0'>{this.renderName()}</p>
                    <p className='has-margin-0'>
                        {this.renderBirthDate()} {this.renderBirthTime('Header')}
                    </p>
                    <p>{this.renderBirthLocation()}</p>
                </div>
            );
        }

        return null;
    }
    /* eslint-enable max-len */

    renderName = () => {
        let name = this.props.report.product.inputs.person_1_name.first;

        if (this.props.report.product.inputs.person_1_name.last) {
            name = `${name} ${this.props.report.product.inputs.person_1_name.last}`;
        }

        return name;
    }

    renderBirthDate = () => {
        return dayjs(this.props.report.product.inputs.person_1_birth_date, 'YYYY-MM-DD').format('MMMM D, YYYY');
    }

    renderBirthTime = (location) => {
        if (this.props.report.product.inputs.person_1_birth_time) {
            return dayjs(this.props.report.product.inputs.person_1_birth_time, 'HH:mm:ss').format('h:mm A');
        }

        return [
            <span className='is-visible-print'>-- Time Unknown</span>,
            <Suspense fallback={<div className='skeleton' />}>
                <Tooltip
                    location={location}
                    content={this.props.report.product.display.sections[1].help.no_birth_time.body}
                    text='Time Unknown'
                />
            </Suspense>,
        ];
    }

    renderBirthLocation = () => {
        let location = `${this.props.report.product.inputs.person_1_birth_location.city}`;

        if (this.props.report.product.inputs.person_1_birth_location.state) {
            location = `${location}, ${this.props.report.product.inputs.person_1_birth_location.state}`;
        }

        if (this.props.report.product.inputs.person_1_birth_location.country != 'United States') {
            location = `${location}, ${this.props.report.product.inputs.person_1_birth_location.country}`;
        }

        return location;
    }

    renderFooter = () => {
        if (!this.props.route || (!this.props.route.match(/^your-report/) && !this.props.route.match(/^glossary/))) {
            this.prev_link = {
                href: 'glossary',
                text: 'Glossary',
            };

            this.next_link = {
                href: 'your-report',
                text: 'Your Report',
            };
        } else if (this.props.route.match(/^your-report/)) {
            this.getReportLinks();
        } else if (this.props.route.match(/^glossary/)) {
            this.getGlossaryLinks();
        }

        if (this.prev_link && this.next_link) {
            return (
                <section className='ulr-footer is-hidden-print'>
                    <row className='is-aligned-center'>
                        <column className='is-4 is-5-mobile has-padding-5-left-mobile'>
                            <a
                                href={`#${this.prev_link.href}`}
                                className='has-text-boulder'
                                onClick={reportGoTo}
                            >
                                <span className='left-arrow'>&#9656;</span> {this.prev_link.text}
                            </a>
                        </column>
                        <column className='is-4 is-2-mobile has-text-center'>
                            <PrintIcon selector='ultimate-love-report' />
                        </column>
                        <column className='is-4 is-5-mobile has-text-right has-padding-5-right-mobile'>
                            <a
                                href={`#${this.next_link.href}`}
                                className='has-text-boulder'
                                onClick={reportGoTo}
                            >
                                {this.next_link.text} <span>&#9656;</span>
                            </a>
                        </column>
                    </row>
                </section>
            );
        }

        return (
            <row className='is-aligned-center is-hidden-print ulr-footer'>
                <column className='is-12 has-text-center'>
                    <PrintIcon />
                </column>
            </row>
        );
    }

    renderPrintFooter = () => {
        return (
            <section className='ulr-print-footer is-visible-print'>
                <row className='is-aligned-center'>
                    <column className='is-4 has-padding-15-left'>
                        {this.props.report.product.display.name}
                    </column>
                    <column className='is-4 has-text-center'>
                        <img
                            loading='lazy'
                            src='https://gfx.tarot.com/images/site/logo/logo.svg'
                            alt='Tarot.com'
                        />
                    </column>
                    <column className='is-4 has-text-right has-padding-15-right'>
                        © Zappallas USA {dayjs().year()}
                    </column>
                </row>
            </section>
        );
    }

    getReportLinks = () => {
        let your_report_links = [];

        this.props.report.product.navigator.map(section => {
            if (section.prefix && section.prefix != '0:' && section.code != 'glossary') {
                your_report_links.push({
                    text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                    href: `your-report-${section.code.replace(/_/g, '-')}`,
                });
            }
        });

        if (this.props.route == 'your-report' || this.props.route.match(your_report_links[0].href)) {
            this.prev_link = {
                text: 'Your Birth Chart',
                href: 'your-birth-chart',
            };

            this.next_link = {
                text: your_report_links[1].text,
                href: your_report_links[1].href,
            };
        } else {
            your_report_links.forEach((yr, i) => {
                if (this.props.route.match(yr.href)) {
                    this.prev_link = {
                        text: your_report_links[i - 1].text,
                        href: your_report_links[i - 1].href,
                    };

                    if (this.props.route.match(yr.href) && i != your_report_links.length - 1) {
                        this.next_link = {
                            text: your_report_links[i + 1].text,
                            href: your_report_links[i + 1].href,
                        };
                    } else {
                        this.next_link = {
                            text: 'Glossary',
                            href: 'glossary',
                        };
                    }
                }
            });
        }
    }

    getGlossaryLinks = () => {
        const glossary = [
            {
                text: 'Planets',
                href: 'glossary-planets',
            },
            {
                text: 'Elements',
                href: 'glossary-elements',
            },
            {
                text: 'Houses & Meaning',
                href: 'glossary-houses-meaning',
            },
            {
                text: 'Aspects',
                href: 'glossary-aspects',
            },
        ];

        if (this.props.route && this.props.route.match(/^glossary/)) {
            if (this.props.route == 'glossary' || this.props.route == glossary[0].href) {
                this.prev_link = {
                    href: 'your-report',
                    text: 'Your Report',
                };

                this.next_link = {
                    href: glossary[1].href,
                    text: glossary[1].text,
                };
            } else if (this.props.route == glossary[3].href) {
                this.prev_link = {
                    href: glossary[2].href,
                    text: glossary[2].text,
                };

                this.next_link = {
                    href: 'your-birth-chart',
                    text: 'Your Birth Chart',
                };
            } else {
                glossary.map((item, i) => {
                    if (this.props.route == item.href) {
                        this.prev_link = {
                            href: glossary[i - 1].href,
                            text: glossary[i - 1].text,
                        };

                        this.next_link = {
                            href: glossary[i + 1].href,
                            text: glossary[i + 1].text,
                        };
                    }
                });
            }
        }
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    logged_in: state.user && state.user.logged_in,
    has_birth_time: state.report && state.report.product && state.report.product.restrictions
        && state.report.product.restrictions[0] && state.report.product.restrictions[0] == 'has_birth_time',
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);